<scitis-breadcrumb [breadcrumbRoutes]="breadcrumbRoutes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div header-title>
    <scitis-page-header-logo-and-name
        [machineCategory]="pageGlobalParameters.machineCategory"
        [pageName]="pageGlobalParameters.pageName"
        [machineId]="pageGlobalParameters.machineId"
        [machineMenuItem]="pageGlobalParameters.associatedMenuItem.menuItemParent"
        [pageType]="pageGlobalParameters.pageType">

    </scitis-page-header-logo-and-name>
  </div>

  <ng-template #filterElement>
    <scitis-tableau-page-actions
        (tableauPageConfigurationChange)="onTableauPageConfigurationChanged($event)"
        [machineOrGroupId]="machineOrGroupId"
        [machine]="machine"
        [isAdmin]="isAdmin"
        [isLowerThanAdmin]="isLowerThanAdmin"
        [pageParentType]="pageGlobalParameters.parentType"
        [tableauPageConfiguration]="tableauPageConfiguration"
        [allDataIsLoaded]="dataIsLoaded">
    </scitis-tableau-page-actions>
  </ng-template>
</scitis-app-global-page-header>
<div class="page-content">
  <scitis-tableau-page [organization]="organization"
                       [tableauPageConfiguration]="tableauPageConfiguration"></scitis-tableau-page>
</div>
